import React from 'react';

/**
 * Date template
 */
export const DateTemplate: React.FC<{ date?: string | null }> = ({ date }) => {
  if (!date) return <span>-</span>;
  return <span>{new Date(date).toLocaleDateString()}</span>;
};

export default DateTemplate;
